<template>
    <div :class="{'share_wrap':true,'share_wrap_fixed':isFixed}">
        <button @click="showGuide">一键分享</button>
        <div v-show="show" class="guide" @click.stop="showGuide">
            <img class="share_hand" src="~@/assets/images/user/housev2/share_hand.png"
                 alt="手"/>
            <div class="share_hint">
                <img class="share_icon" src="~@/assets/images/user/housev2/share_icon.png" alt="分享"/>
                <p>点击 “...” 去分享</p>
            </div>
        </div>
    </div>
</template>

<script>
import {getWxSingleConfig} from "@/js/wx.js";
import {getReportShare} from "@/js/member/mynews/index.js";
export default {
    name: "share",
    props: {
        isFixed: {
            type: Boolean,
            default: false,
        },
        isHouse: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: "交付在线"
        }
    },
    data() {
        return {
            show: false
        }
    },
    created() {
        getWxSingleConfig().then((res) => {
            wx.ready(() => {
                wx.hideMenuItems({
                    menuList: ["menuItem:share:appMessage", "menuItem:share:wechat", "menuItem:copyUrl"]
                });
            })
        })
    },
    mounted() {
    },
    methods: {
        setShare(id = '') {
            let data = {
                share_friend_title: (this.isHouse ? this.$storage.getStorage('new_house') : this.title) + '-' + document.title,
                share_friend_desc: '施工全流程在线交付 有源可溯',
                share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                share_link: `${window.location.protocol}//${window.location.host}/member/v2/index/index?shareId=${id}`,
            }
            getWxSingleConfig(data).then((res) => {
                wx.ready(() => {
                    wx.showMenuItems({
                        menuList: ["menuItem:share:appMessage", "menuItem:share:wechat"]
                    });
                })
            })
        },
        showGuide() {
            if (this.show) {
                this.show = false;
            } else {
                let shareData = {
                    project_uuid:this.$storage.getStorage('project_uuid') || '',
                }
                getReportShare(shareData).then(res=>{
                    this.setShare(res.data.data.result.id);
                })
                this.show = true;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.share_wrap {
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
    background: #ffffff;
    border-radius: 20px 20px 0 0;

    button {
        width: 686px;
        height: 72px;
        background: #355D4B;
        border-radius: 36px;
        margin: 0 auto;
        display: block;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 72px;
    }
}

.guide {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);

    .share_hand {
        width: 90px;
        height: 121px;
        margin: 25px 10px 0 auto;
        display: block;
    }

    .share_hint {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        p {
            font-size: 43px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 48px;
            text-align: center;
        }
    }

    .share_icon {
        width: 108px;
        height: 108px;
        display: block;
        margin: 0 auto 65px;
    }
}

.share_wrap_fixed {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 7;
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
}
</style>
